"use client";

import { useEffect, useState, useRef, useCallback } from "react";
import {
  Box,
  Container,
  Typography,
  Card,
  CardContent,
  Grid,
  TextField,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  Chip,
  IconButton,
  Button,
  Slider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Divider,
  Paper,
  useTheme,
  useMediaQuery,
  InputAdornment,
} from "@mui/material";
import {
  Search,
  FilterList,
  Favorite,
  FavoriteBorder,
  Email,
  Phone,
  WhatsApp,
  Bed,
  Bathtub,
  SquareFoot,
  LocationOn,
  CheckCircle,
  ArrowBackIos,
  ArrowForwardIos,
  ExpandMore,
  ViewList,
  ViewModule,
  Info,
} from "@mui/icons-material";
import LocalParkingIcon from "@mui/icons-material/LocalParking";

import PropertyServices from "../../../api/PropertyServices/property.index";
import Header from "../Header";
import PropertyHeader from "../../../views/web/Property/Property_Header";
import { Images } from "../../../assets/images";
import { useNavigate, useParams } from "react-router-dom";
import Colors from "../../../assets/styles";
import { useLocation } from "react-router-dom";
import Loader from "../../../components/Loader";
import SimpleDialog from "../../../components/Dialog";
import { useForm } from "react-hook-form";
import moment from "moment";
import { useAuth } from "../../../context";
import { ErrorToaster, SuccessToaster } from "../../../components/Toaster";

import AuthServices from "../../../api/AuthServices/auth.index";
import { trackGtmEvent } from "../../../utils/gtm";

const ProfessionalPropertyListing = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [viewMode, setViewMode] = useState("grid");
  const [properties, setProperties] = useState([]);
  const [loading, setLoading] = useState(false);
  const [id, setId] = useState("");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [count, setCount] = useState(0);
  const intervalRef = useRef({});
  const [debouncedSearch, setDebouncedSearch] = useState("");
  const [maxMin, setMaxMin] = useState(null);
  const [openStatus, setOpenStatus] = useState(false);
  const { WebUserLogin, webUser } = useAuth();
  const [openBookDialog, setOpenBookDialog] = useState(false);
  const [openRequestDialog, setOpenRequestDialog] = useState(false);
  const [propertyData, setPropertyData] = useState([]);
  const [bookingLoading, setBookingLoading] = useState(false);


  const {
    register,
    handleSubmit,
    control,
    setValue,
    watch,
    reset,
    formState: { errors },
  } = useForm();

  const {
    register: registerRequest,
    handleSubmit: handleSubmitRequest,
    reset: resetRequest,
    formState: { errors: requestErrors },
  } = useForm();

  const selectedTime = watch("timeSlot");

  const navigate = useNavigate();
  const useQuery = () => {
    return new URLSearchParams(useLocation().search);
  };

  const query = useQuery();
  // console.log(query, "query");
  const location = query.get("location");
  const type = query.get("type") || "";
  const priceMin = query.get("priceMin");
  const priceMax = query.get("priceMax");
  const purpose = query.get("purpose") || "";


  // Get the current path
  const currentPath = window.location.pathname;

  // Dynamically render the header based on the path
  const HeaderComponent = currentPath.includes("/property-list")
    ? PropertyHeader
    : Header;

  const handleSearchChange = useCallback((value) => {
    setSearch(value);
  }, []);

  useEffect(() => {
    setSearch(location ? location : "");

    setFilters((prev) => ({
      ...prev,
      propertyType: filters?.propertyType ? filters?.propertyType : type,
      purpose: filters?.purpose ? filters?.purpose : purpose,
      priceRange: [
        priceMin !== null && !isNaN(priceMin) ? priceMin : prev.priceRange[0],
        priceMax !== null && !isNaN(priceMax) ? priceMax : prev.priceRange[1],
      ],
    }));
  }, [priceMin, priceMax, location, type, purpose]);

  const handleMouseEnter = (property) => {
    const total = property.images.length;
    const id = property._id;

    if (intervalRef.current[id]) return;

    intervalRef.current[id] = setInterval(() => {
      setCurrentImageIndexes((prev) => {
        const current = prev[id] ?? 0;
        return {
          ...prev,
          [id]: (current + 1) % total,
        };
      });
    }, 2000);
  };
  const formatPrice = (price) => {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "AED",
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(price);
  };

  const handleMouseLeave = (propertyId) => {
    clearInterval(intervalRef.current[propertyId]);
    delete intervalRef.current[propertyId];
  };
  useEffect(() => {
    return () => {
      Object.values(intervalRef.current).forEach(clearInterval);
    };
  }, []);

  const getProperties = async (
    searchParam = "",
    idParam = "",
    pageParam = 1,
    limitParam = 10,
    append = false,
    priceMin = "",
    priceMax = "",
    type = "",
    purpose = "",
    areaMin = "",
    areaMax = "",
    dateFrom = "",
    dateTo = ""
  ) => {
    setLoading(true);
    try {
      const { data } = await PropertyServices.getProperty(
        searchParam ? searchParam : location ? location : "",
        idParam,
        pageParam,
        limitParam,

        priceMin,
        priceMax,

        type,
        purpose,

        areaMin,
        areaMax,

        dateFrom,
        dateTo
      );
      setMaxMin(data);
      setProperties((prev) =>
        append ? [...prev, ...data?.properties] : data?.properties
      );
      setCount(data.count);
      if (filters.priceRange[0] === "" && filters.priceRange[1] === "") {
        setFilters((prev) => ({
          ...prev,
          priceRange: [data.min_price, data.max_price]
        }));
      }
      if (filters.area[0] === "" && filters.area[1] === "") {
        setFilters((prev) => ({
          ...prev,
          area: [data.min_area, data.max_area]
        }));
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false);
    }
  };
  const timeSlots = [
    "9-10",
    "10-11",
    "11-12",
    "12-13",
    "13-14",
    "14-15",
    "15-16",
    "16-17",
    "17-18",
    "18-19",
    "19-20",
    "20-21"
  ];
  const onSubmit = async (data) => {
    setBookingLoading(true);
    const obj = {
      name: webUser?.name,
      email: webUser?.email,
      agent_id: webUser?._id,
      property_id: propertyData?._id,
      // doc: document,
      date: data?.date,
      time: data?.timeSlot,
      client_name: data?.clientName,
      notes: data?.notes,
    };
    // console.log(obj);
    try {
      const response = await AuthServices.createBooking(obj);
      trackGtmEvent("book_visit_submit", {
        property_id: propertyData?._id,
        property_name: propertyData?.name,
        date: data?.date,
        time: data?.timeSlot,
      });
      SuccessToaster(response?.message);
      setOpenBookDialog(false);
      reset();
      setValue("timeSlot", "");
      // setDocument(null);
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setBookingLoading(false);
    }
  };
  const onRequestListingSubmit = async (data) => {
    setBookingLoading(true);
    if (new Date(data?.toDate) <= new Date(data?.fromDate)) {
      ErrorToaster("To date must be greater than From date");
      setBookingLoading(false);
      return;
    }
    const obj = {
      name: webUser?.name,
      email: webUser?.email,
      agent_id: webUser?._id,
      property_id: propertyData?._id,
      from_date: data?.fromDate,
      to_date: data?.toDate,
      client_type: data?.clientType,
      purpose: data?.purpose,
    };
    try {
      const response = await AuthServices.createRequestListing(obj);
      trackGtmEvent("request_listing_submit", {
        property_id: propertyData?._id,
        property_name: propertyData?.name,
        purpose: data?.purpose,
      });
      SuccessToaster(response?.message);
      setOpenRequestDialog(false);
      resetRequest();
    } catch (error) {
      ErrorToaster(error);
    } finally {
      setBookingLoading(false);
    }
  };

  const [filters, setFilters] = useState({
    location: "",
    propertyType: "",
    priceRange: ["", ""],
    bedrooms: "",
    bathrooms: "",
    area: ["", ""],
    purpose: "",
    dateAdded: ["", ""],
  });
  // console.log(filters);

  useEffect(() => {
    const debounceTimeout = setTimeout(() => {
      setPage(0);

      getProperties(
        search,
        id,
        1,
        limit,
        false,
        "",
        "",
        filters?.propertyType == ""
          ? ""
          : filters?.propertyType
            ? filters.propertyType
            : type,
        filters?.purpose == "" ? "" : filters?.purpose ? filters.purpose : type
      );
    }, 1000);

    return () => clearTimeout(debounceTimeout);
  }, []);

  const handleShowMore = () => {
    const nextPage = page + 1;
    setPage(nextPage);
    getProperties(
      search,
      id,
      nextPage + 1,
      limit,
      true,
      filters?.priceRange[0],
      filters?.priceRange[1],
      filters?.propertyType === ""
        ? ""
        : filters?.propertyType
          ? filters.propertyType
          : type,
      filters?.purpose === ""
        ? ""
        : filters?.purpose
          ? filters.purpose
          : purpose,
      filters?.area[0],
      filters?.area[1],
      filters?.dateAdded[0],
      filters?.dateAdded[1]
    );
  };

  const [currentImageIndexes, setCurrentImageIndexes] = useState({});
  const [selectedProperty, setSelectedProperty] = useState(null)
  const PropertyCard = ({ property }) => {
    const currentImageIndex = currentImageIndexes[property.id] || 0;

    return (
      <Card
        sx={{
          borderRadius: 3,
          boxShadow: "0 2px 12px rgba(0,0,0,0.08)",
          overflow: "hidden",
          mb: 3,
          transition: "all 0.3s ease",
          "&:hover": {
            boxShadow: "0 4px 20px rgba(0,0,0,0.12)",
          },
          cursor: "pointer",
        }}

      >
        <Grid container>
          {/* Image Section */}
          <Grid item xs={12} md={5}>
            <Box
              sx={{ position: "relative", height: { xs: 250, md: 420 } }}
              onMouseEnter={() => handleMouseEnter(property)}
              onMouseLeave={() => handleMouseLeave(property._id)}
            >
              <Box
                component="img"
                src={property.images[currentImageIndexes[property._id] ?? 0]}
                alt={`${property.name} - ${property.type === 'commercialOffice' ? 'Commercial Office' : property.type || 'Property'} in ${property.address || 'Dubai'}`}
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                }}
              />

              {/* Dots */}
              {property.images.length > 1 && (
                <Box
                  sx={{
                    position: "absolute",
                    bottom: 16,
                    left: "50%",
                    transform: "translateX(-50%)",
                    display: "flex",
                    gap: 0.5,
                  }}
                >
                  {property.images.map((_, index) => (
                    <Box
                      key={index}
                      onClick={() =>
                        setCurrentImageIndexes((prev) => ({
                          ...prev,
                          [property._id]: index,
                        }))
                      }
                      sx={{
                        width: 8,
                        height: 8,
                        borderRadius: "50%",
                        backgroundColor:
                          index === (currentImageIndexes[property._id] ?? 0)
                            ? "white"
                            : "rgba(255, 255, 255, 0.5)",
                        cursor: "pointer",
                        transition: "all 0.3s ease",
                      }}
                    />
                  ))}
                </Box>
              )}
            </Box>
          </Grid>

          {/* Content Section */}
          <Grid item xs={12} md={7}>
            <Box sx={{ p: { xs: 2, md: 3 }, height: "100%" }}>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                }}
              >
                {/* Price */}
                <Grid container alignItems="center" justifyContent="space-between" spacing={2} mb={2}>
                  {/* Buttons - shown first on xs */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    sx={{ order: { xs: 1, sm: 2 } }}
                  >
                    <Box display="flex" justifyContent={{ xs: "center", sm: "flex-end", md: "flex-end" }} gap={1} flexWrap="nowrap" sx={{ overflowX: "auto" }}>
                      {property.status !== "sold" ? (
                        <>
                          <Button
                            variant="contained"
                            color="primary"
                            sx={{ textTransform: "none", fontWeight: 600, whiteSpace: "nowrap", fontSize: { xs: "12px", sm: "13px", md: "14px" }, px: { xs: 1.5, sm: 1.5 } }}
                            onClick={() => {
                              if (webUser?.token) {
                                setPropertyData(property);
                                setOpenBookDialog(true);
                              } else {
                                const currentPath = window.location.pathname;
                                navigate(`/agent/login?redirect=${encodeURIComponent(currentPath)}`);
                                ErrorToaster("Please login to book a property");
                              }
                            }}
                          >
                            Book a Visit
                          </Button>
                          <Button
                            variant="contained"
                            color="primary"
                            sx={{ textTransform: "none", fontWeight: 600, whiteSpace: "nowrap", fontSize: { xs: "12px", sm: "13px", md: "14px" }, px: { xs: 1.5, sm: 1.5 } }}
                            onClick={() => {
                              if (webUser?.token) {
                                setPropertyData(property);
                                setOpenRequestDialog(true);
                              } else {
                                const currentPath = window.location.pathname;
                                navigate(`/agent/login?redirect=${encodeURIComponent(currentPath)}`);
                                ErrorToaster("Please login to request a listing");
                              }
                            }}
                          >
                            Request listing
                          </Button>
                        </>
                      ) : (
                        <Chip label="Sold" color="error" sx={{ fontSize: "14px", fontWeight: "bold" }} />
                      )}
                      <Button
                        variant="outlined"
                        color="primary"
                        sx={{ textTransform: "none", fontWeight: 600, whiteSpace: "nowrap", fontSize: { xs: "12px", sm: "13px", md: "14px" }, px: { xs: 1.5, sm: 1.5 } }}
                        onClick={() => {
                          if (webUser?.token) {
                            navigate(`/property-detail/${property._id}`)
                          } else {
                            navigate("/agent/login");
                            ErrorToaster("Please login to View Detail");
                          }
                        }}
                      >
                        View Details
                      </Button>

                    </Box>
                  </Grid>

                  {/* Property Name - shown second on xs */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={6}
                    sx={{ order: { xs: 2, sm: 1 } }}
                  >
                    <Typography
                      variant="h4"
                      sx={{
                        fontWeight: 700,
                        color: "#2d3748",
                        fontSize: { xs: "1.5rem", md: "2rem" },
                      }}
                      onClick={() => {
                        if (webUser?.token) {
                          navigate(`/property-detail/${property._id}`)
                        } else {
                          navigate("/agent/login");
                          ErrorToaster("Please login to View Detail");
                        }
                      }}
                    >
                      {property.name}
                    </Typography>
                  </Grid>
                </Grid>



                {/* Property Details */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 3,
                    mb: 2,
                    flexWrap: "wrap",
                  }}
                >
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      color: "#2d3748",
                      textTransform: "capitalize",
                    }}
                  >
                    {property.type == "commercialOffice"
                      ? "Commercial Office"
                      : ""}
                  </Typography>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                    >
                      <LocalParkingIcon sx={{ fontSize: 18, color: "#666" }} />
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 600, color: "#2d3748" }}
                      >
                        {property?.parking_space}
                      </Typography>
                    </Box>

                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                    >
                      <Typography
                        variant="body1"
                        sx={{ fontWeight: 600, color: "#2d3748" }}
                      >
                        Area: {property.area} sqft
                      </Typography>
                    </Box>
                  </Box>
                </Box>

                {/* Title */}
                <Typography
                  variant="body1"
                  sx={{
                    color: "#3182ce",
                    mb: 2,
                    fontWeight: 500,
                    fontSize: "1rem",
                    textTransform: "capitalize ",
                  }}
                >
                  {property.features?.join(" | ")}
                </Typography>

                {/* Location */}
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "flex-start",
                    gap: 1,
                    mb: 2,
                  }}
                >
                  <LocationOn sx={{ fontSize: 18, color: "#666", mt: 0.2 }} />
                  <Typography
                    variant="body1"
                    sx={{
                      color: "#666",
                      lineHeight: 1.5,
                    }}
                  >
                    {property.address}
                  </Typography>
                </Box>

                {/* Handover and Payment Plan */}
                {/* <Box sx={{ display: "flex", gap: 4, mb: 3 }}>
                  <Box>
                    <Typography
                      variant="caption"
                      sx={{
                        color: "#666",
                        textTransform: "uppercase",
                        fontWeight: 600,
                        fontSize: "0.75rem",
                      }}
                    >
                    Total Selling Price
                    </Typography>
                    <Typography
                      variant="body1"
                      sx={{ fontWeight: 600, color: "#2d3748" }}
                    >
                      {formatPrice(property.price)}
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      variant="caption"
                      sx={{
                        color: "#666",
                        textTransform: "uppercase",
                        fontWeight: 600,
                        fontSize: "0.75rem",
                      }}
                    >
                      Selling price per (sqft)
                    </Typography>
                    <Box
                      sx={{ display: "flex", alignItems: "center", gap: 0.5 }}
                    >
                      <Typography
                        variant="body1"
                        sx={{
                          fontWeight: 600,
                          color: "#2d3748",
                          textTransform: "capitalize",
                        }}
                      >
                        {formatPrice(property?.selling_price_sqft)}
                      </Typography>
                    </Box>
                  </Box>
                </Box> */}

                <Box sx={{ display: "flex", gap: 4, mb: 3, alignItems: "center", flexWrap: "wrap" }}>

                  {webUser?.token && (
                    <Box
                      sx={{
                        display: "flex",
                        gap: 4,
                        mb: 3,
                        alignItems: "center",
                        flexWrap: "wrap",
                      }}
                    >
                      {/* Annual Rental Price */}
                      <Box>
                        <Typography
                          variant="caption"
                          sx={{
                            color: "#666",
                            textTransform: "uppercase",
                            fontWeight: 600,
                            fontSize: "0.75rem",
                          }}
                        >
                          Annual Rental Price
                        </Typography>

                        {property?.rental_price ? (
                          <Typography variant="body1" sx={{ fontWeight: 600, color: "#2d3748" }}>
                            {property.rental_price}
                          </Typography>
                        ) : null}
                      </Box>

                      {/* Sale Value */}
                      <Box>
                        <Typography
                          variant="caption"
                          sx={{
                            color: "#666",
                            textTransform: "uppercase",
                            fontWeight: 600,
                            fontSize: "0.75rem",
                          }}
                        >
                          Sale Value
                        </Typography>

                        {property?.sale_price ? (
                          <Typography variant="body1" sx={{ fontWeight: 600, color: "#2d3748" }}>
                            {property.sale_price}
                          </Typography>
                        ) : null}
                      </Box>

                      {/* Rental Price Per Sqft */}
                      <Box>
                        <Typography
                          variant="caption"
                          sx={{
                            color: "#666",
                            textTransform: "uppercase",
                            fontWeight: 600,
                            fontSize: "0.75rem",
                          }}
                        >
                          Rental price per (sqft)
                        </Typography>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                          {property?.rental_price_per_sqft ? (
                            <Typography
                              variant="body1"
                              sx={{
                                fontWeight: 600,
                                color: "#2d3748",
                                textTransform: "capitalize",
                              }}
                            >
                              {formatPrice(property.rental_price_per_sqft)}
                            </Typography>
                          ) : null}
                        </Box>
                      </Box>
                    </Box>
                  )}


                  {property?.rented_vacant === "rented" && (
                    <>
                      <Box>
                        <Typography
                          variant="caption"
                          sx={{
                            color: "#666",
                            textTransform: "uppercase",
                            fontWeight: 600,
                            fontSize: "0.75rem",
                          }}
                        >
                          Status
                        </Typography>

                        <Box sx={{ display: "flex", alignItems: "center", gap: 1, mt: 0.5 }}>
                          <Typography
                            variant="body2"
                            sx={{ textTransform: "capitalize", fontWeight: 600 }}
                          >
                            {property?.rented_vacant}
                          </Typography>


                        </Box>
                      </Box>

                      <Box>
                        <Button
                          size="small"
                          variant="outlined"
                          sx={{ fontWeight: "bold", height: "44px" }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setSelectedProperty(property);
                            setOpenStatus(true);
                          }}
                        >
                          View Rent Details
                        </Button>
                      </Box>
                    </>
                  )}

                </Box>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </Card>
    );
  };

  const applyFilters = () => {
    const [from, to] = filters?.dateAdded || ["", ""];
    if (to && from && moment(to).isBefore(moment(from))) {
      ErrorToaster("Posted To date cannot be before Posted From date");
      return;
    }
    setPage(0);
    getProperties(search, id, 1, limit, false, filters?.priceRange[0], filters?.priceRange[1], filters?.propertyType == "" ? "" : filters?.propertyType ? filters.propertyType : type, filters?.purpose == "" ? "" : filters?.purpose ? filters.purpose : type, filters?.area[0], filters?.area[1], filters?.dateAdded[0], filters?.dateAdded[1]
    );
  }

  const resetFilters = () => {
    setFilters({
      priceRange: [maxMin.min_price, maxMin.max_price],
      propertyType: "",
      purpose: "",
      area: [maxMin.min_area, maxMin.max_area],
      dateAdded: ["", ""],
    });
    setPage(0);
    getProperties(search, id);
  };

  return (
    <>
      {HeaderComponent && <HeaderComponent />}
      <Box sx={{ backgroundColor: "#f8fafc", minHeight: "130vh" }}>
        <Box
          sx={{
            // minHeight: "100vh",
            backgroundImage: `url(${Images.RRPropertyList})`,
            backgroundSize: "cover",
            backgroundPosition: "center",
            backgroundRepeat: "no-repeat",
            backgroundAttachment: "fixed",
            pt: 4,
            pb: 8,
          }}
        >
          <Container sx={{ py: 4, maxWidth: "1300px !important" }}>
            {/* Header */}
            <Box sx={{ mb: 4 }}>
              <Typography
                variant="h3"
                sx={{
                  fontWeight: 700,
                  mb: 1,
                  fontFamily: "'Gotham-Book', sans-serif",
                  fontSize: { xs: "2rem", md: "3rem" },
                  color: "white",

                }}
              >
                Premium Properties
              </Typography>
              <Typography
                variant="h6"
                sx={{
                  color: "white",
                  fontFamily: "'Gotham-Light', sans-serif",
                  textShadow: "2px 2px 4px rgba(0,0,0,0.5)",
                  fontWeight: 400,
                }}
              >
                Discover luxury homes and investment opportunities
              </Typography>
            </Box>

            {/* Filters Section */}
            <Paper
              elevation={0}
              sx={{
                p: 3, // tighter padding
                mb: 2, // smaller margin
                borderRadius: 2,
                border: "1px solid #e2e8f0",
                backgroundColor: "white",
              }}
            >
              <Box sx={{ display: "flex", alignItems: "center", gap: 1, mb: 1.5 }}>
                <FilterList sx={{ color: "#4a5568", fontSize: 18 }} />
                <Typography variant="subtitle2" sx={{ fontWeight: 600, color: "#2d3748" }}>
                  Search Filters
                </Typography>
              </Box>

              <Grid container spacing={2}>
                <Grid item xs={12} md={4}>
                  <TextField
                    fullWidth
                    size="small"
                    placeholder="Search by name"
                    value={search}
                    onChange={(e) => handleSearchChange(e.target.value)}
                    InputProps={{
                      startAdornment: (
                        <InputAdornment position="start">
                          <Search sx={{ color: "#718096", fontSize: 18 }} />
                        </InputAdornment>
                      ),
                    }}
                  />
                </Grid>

                <Grid item xs={12} md={2}>
                  <FormControl fullWidth size="small">
                    <InputLabel>Purpose</InputLabel>
                    <Select
                      value={filters.purpose}
                      label="Purpose"
                      onChange={(e) =>
                        setFilters({ ...filters, purpose: e.target.value })
                      }
                    >
                      <MenuItem value="">Both</MenuItem>
                      <MenuItem value="sale">Sale</MenuItem>
                      <MenuItem value="rent">Rent</MenuItem>
                    </Select>
                  </FormControl>
                </Grid>

                <Grid item xs={6} md={3}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Posted From"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={filters.dateAdded[0]}
                    inputProps={{ max: new Date().toISOString().split("T")[0] }}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        dateAdded: [e.target.value, filters.dateAdded[1]],
                      })
                    }
                  />
                </Grid>

                <Grid item xs={6} md={3}>
                  <TextField
                    fullWidth
                    size="small"
                    label="Posted To"
                    type="date"
                    InputLabelProps={{ shrink: true }}
                    value={filters.dateAdded[1]}
                    inputProps={{ max: new Date().toISOString().split("T")[0] }}
                    onChange={(e) =>
                      setFilters({
                        ...filters,
                        dateAdded: [filters.dateAdded[0], e.target.value],
                      })
                    }
                  />
                </Grid>

                {maxMin && (
                  <>
                    <Grid item xs={12} md={3}>
                      <Typography variant="caption" fontWeight={600}>
                        Price Range (AED)
                      </Typography>

                      <Slider
                        value={filters.priceRange}
                        onChange={(e, v) =>
                          setFilters({ ...filters, priceRange: v })
                        }
                        min={maxMin.min_price}
                        max={maxMin.max_price}
                        step={10000}
                        valueLabelDisplay="auto"
                        valueLabelFormat={(v) => `${v.toLocaleString()} AED`}
                        sx={{ color: Colors.primary }}
                      />

                      <Typography variant="caption" color="text.secondary">
                        {filters.priceRange[0].toLocaleString()} –{" "}
                        {filters.priceRange[1].toLocaleString()} AED
                      </Typography>
                    </Grid>

                    <Grid item xs={12} md={3} marginLeft={2} marginRight={2}>
                      <Typography variant="caption" fontWeight={600}>
                        Size Range (sqft)
                      </Typography>

                      <Slider
                        value={filters.area}
                        onChange={(e, v) =>
                          setFilters({ ...filters, area: v })
                        }
                        min={maxMin.min_area}
                        max={maxMin.max_area}
                        step={100}
                        valueLabelDisplay="auto"
                        valueLabelFormat={(v) => `${v} sqft`}
                        sx={{ color: Colors.primary }}
                      />

                      <Typography variant="caption" color="text.secondary">
                        {filters.area[0]} – {filters.area[1]} sqft
                      </Typography>
                    </Grid>
                  </>
                )}
                <Grid
                  item
                  xs={12}
                  md={4}
                  sx={{ display: "flex", gap: 1, alignItems: "center" }}
                >
                  <Button
                    fullWidth
                    variant="contained"
                    sx={{ color: "white", bgcolor: Colors.primary, height: 40 }}
                    onClick={applyFilters}
                  >
                    Apply
                  </Button>

                  <Button
                    fullWidth
                    variant="outlined"
                    sx={{ height: 40 }}
                    onClick={() => {
                      setSearch("");
                      resetFilters();
                    }}
                  >
                    Reset
                  </Button>
                </Grid>
              </Grid>

            </Paper>

            {webUser?.token && (
              <>
                <Paper
                  elevation={0}
                  sx={{
                    mt: 0,
                    borderRadius: 2,
                    border: "1px solid #e2e8f0",
                    overflow: "hidden",
                    backgroundColor: "#fff",
                    display: "block",
                  }}
                >
                  <Box
                    sx={{
                      px: 2,
                      py: 1.5,
                      // borderBottom: "1px solid #e2e8f0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography sx={{ fontWeight: 600, color: "#2d3748" }}>
                      Market Sheet (Live)
                    </Typography>
                  </Box>
                  <Box sx={{ height: 500, overflow: "hidden", position: "relative" }}>
                    <iframe
                      title="Google Sheet Preview"
                      src="https://docs.google.com/spreadsheets/d/e/2PACX-1vQ2-P38LQVmbI9osus1w-MRD3qYc16yECzY0vE88tW_r9HAaQm9j9Ry8uL5hxwYEQ/pubhtml?gid=1179682924&single=true"
                      width="100%"
                      height="500"
                      style={{
                        border: "none",
                      }}
                    />
                  </Box>
                </Paper>
                <Paper
                  elevation={0}
                  sx={{
                    mt: 2,
                    borderRadius: 2,
                    border: "1px solid #e2e8f0",
                    overflow: "hidden",
                    backgroundColor: "#fff",
                    display: "none",
                  }}
                >
                  <Box
                    sx={{
                      px: 2,
                      py: 1.5,
                      // borderBottom: "1px solid #e2e8f0",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography sx={{ fontWeight: 600, color: "#2d3748" }}>
                      RR Property Portfolio : <a href="https://docs.google.com/spreadsheets/d/1rZ_VFTlXk_8CzqYn3O--n5c6WqKbMALU/edit?gid=1179682924#gid=1179682924" target="_blank" rel="noopener noreferrer">View Spreadsheet</a>
                    </Typography>
                  </Box>
                </Paper>
              </>
            )}

          </Container>
        </Box>
        <Container sx={{ py: 4, maxWidth: "1300px !important" }}>
          {/* Results Header */}
          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mb: 3,
            }}
          >
            <Typography variant="h6" sx={{ color: "#4a5568" }}>
              Total Properties : {count}
            </Typography>
          </Box>
          {console.log(properties)}
          {/* Properties Grid */}
          <Grid container spacing={3}>
            {loading ? (
              <Grid item xs={12} display="flex" justifyContent="center" py={5}>
                <Loader width="40px" height="40px" color={Colors.primary} />
              </Grid>
            ) : properties.length === 0 ? (
              <Grid item xs={12} display="flex" justifyContent="center" py={5}>
                <Typography>No properties found</Typography>
              </Grid>
            ) : (
              properties.map((property) => (
                <Grid item xs={12} sm={12} lg={12} key={property._id}>
                  <PropertyCard property={property} />
                </Grid>
              ))
            )}
          </Grid>

          {properties.length < count && (
            <Box sx={{ textAlign: "center", mt: 4 }}>
              <Button
                variant="contained"
                color="primary"
                onClick={handleShowMore}
                disabled={loading}
              >
                {loading ? "Loading..." : "Show More"}
              </Button>
            </Box>
          )}
        </Container>
      </Box>


      <SimpleDialog
        open={openStatus}
        onClose={() => setOpenStatus(false)}
        border={`4px solid ${Colors.primary}`}
        title="Rent Details"
      >
        <Grid container spacing={4} mt={1}>
          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" fontWeight={600} sx={{ textAlign: "center" }}>
              Tenure (Years):
            </Typography>
            <Typography variant="body2" sx={{ textAlign: "center" }}>
              {selectedProperty?.tenure_years || "—"}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" fontWeight={600} sx={{ textAlign: "center" }}>
              Rental Value:
            </Typography>
            <Typography variant="body2" sx={{ textAlign: "center" }}>
              {selectedProperty?.contract_value
                ? formatPrice(selectedProperty.contract_value)
                : "—"}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" fontWeight={600} sx={{ textAlign: "center" }}>
              Lease Start Date:
            </Typography>
            <Typography variant="body2" sx={{ textAlign: "center" }}>
              {selectedProperty?.lease_start_date
                ? moment(selectedProperty.lease_start_date).format("DD-MM-YYYY")
                : "—"}
            </Typography>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography variant="subtitle2" fontWeight={600} sx={{ textAlign: "center" }}>
              Lease End Date:
            </Typography>
            <Typography variant="body2" sx={{ textAlign: "center" }}>
              {selectedProperty?.lease_end_date
                ? moment(selectedProperty.lease_end_date).format("DD-MM-YYYY")
                : "—"}
            </Typography>
          </Grid>
        </Grid>

      </SimpleDialog>


      <SimpleDialog
        open={openBookDialog}
        onClose={() => {
          setOpenBookDialog(false);
          reset();
          setValue("timeSlot", "");
        }}
        border={`4px solid ${Colors.primary}`}
        title={`Book This Property`}
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Grid container spacing={2}>
            {/* Date Picker */}

            <Grid item xs={12} md={12}>
              <InputLabel>Select Date</InputLabel>

              <TextField
                type="date"
                fullWidth
                InputLabelProps={{
                  shrink: true,
                }}
                error={!!errors.date}
                helperText={errors.date?.message}
                {...register("date", { required: "Date is required" })}
              />
            </Grid>

            {/* Time Slot Chips */}
            <Grid item xs={12} md={12}>
              <InputLabel>Select Time Slot</InputLabel>
              <Box sx={{ display: "flex", flexWrap: "wrap", gap: 1, mt: 1 }}>
                {timeSlots.map((slot) => (
                  <Chip
                    key={slot}
                    label={slot}
                    clickable
                    color={selectedTime === slot ? "primary" : "default"}
                    onClick={() =>
                      setValue("timeSlot", slot, { shouldValidate: true })
                    }
                  />
                ))}
              </Box>
              {errors.timeSlot && (
                <Typography color="error" variant="caption">
                  {errors.timeSlot.message}
                </Typography>
              )}
              {/* Hidden time slot input */}
              <input
                type="hidden"
                {...register("timeSlot", { required: "Time slot is required" })}
              />
            </Grid>

            {/* Document Upload */}
            {/* <Grid item xs={12} md={12}>
              <InputLabel>Upload Document</InputLabel>
              <Box
                component="label"
                sx={{
                  border: "2px dashed #ccc",
                  borderRadius: 2,
                  padding: 2,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  cursor: "pointer",
                  bgcolor: "#f9f9f9",
                  gap: 1,
                  flexDirection: "column",
                  textAlign: "center",
                }}
              >
                {docLoading ? (
                  <Loader width="30px" height="30px" color={Colors.primary} />
                ) : (
                  <>
                    <CloudUploadIcon sx={{ fontSize: 28, color: "#999" }} />
                    <Typography variant="caption">
                      {document ? `Document Uploaded` : "Upload RERA Document"}
                    </Typography>
                  </>
                )}
                <input
                  type="file"
                  accept=".pdf,.jpg,.jpeg,.png"
                  hidden
                  {...register("document", {
                    required: "Document is required",
                  })}
                  onChange={handleUploadDoc}
                />
              </Box>
              {errors.document && (
                <Typography color="error" variant="caption">
                  {errors.document.message}
                </Typography>
              )}
            </Grid> */}

            <Grid item xs={12} md={12}>
              <InputLabel>Client Name</InputLabel>

              <TextField
                type="text"
                fullWidth
                placeholder="Client Name"
                InputLabelProps={{
                  shrink: true,
                }}
                {...register("clientName")}
              />
            </Grid>

            <Grid item xs={12} md={12}>
              <InputLabel>Additional Notes </InputLabel>

              <TextField
                type="text"
                fullWidth
                placeholder="Type Additional Notes here"
                InputLabelProps={{
                  shrink: true,
                }}
                {...register("notes")}
              />
            </Grid>

            <Grid item xs={12}>
              <Typography variant="caption" color="textSecondary" sx={{ mt: 2 }}>
                This is private data, for registering purposes only.
              </Typography>
            </Grid>

            {/* Submit Button */}
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                sx={{ color: Colors.white }}
                fullWidth
              >
                {bookingLoading ? (
                  <Loader width="20px" height="20px" color={Colors.white} />
                ) : (
                  "Book a visit"
                )}
              </Button>
            </Grid>
          </Grid>
        </form>
      </SimpleDialog>

      <SimpleDialog
        open={openRequestDialog}
        onClose={() => {
          setOpenRequestDialog(false);
          resetRequest();
        }}
        border={`4px solid ${Colors.primary}`}
        title={"Request Listing"}
      >
        <form onSubmit={handleSubmitRequest(onRequestListingSubmit)}>
          <Grid container spacing={2}>
            {/* Date Picker */}
            <Grid item xs={12} md={12}>
              <Box sx={{ display: "flex", gap: 2 }}>
                <Box sx={{ flex: 1 }}>
                  <InputLabel>Select From Date</InputLabel>
                  <TextField
                    type="date"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{ min: new Date().toISOString().split("T")[0] }}
                    error={!!requestErrors.fromDate}
                    helperText={requestErrors.fromDate?.message}
                    {...registerRequest("fromDate", { required: "From Date is required" })}
                  />
                </Box>
                <Box sx={{ flex: 1 }}>
                  <InputLabel>Select To Date</InputLabel>
                  <TextField
                    type="date"
                    fullWidth
                    InputLabelProps={{
                      shrink: true,
                    }}
                    inputProps={{ min: new Date().toISOString().split("T")[0] }}
                    error={!!requestErrors.toDate}
                    helperText={requestErrors.toDate?.message}
                    {...registerRequest("toDate", { required: "To Date is required" })}
                  />
                </Box>
              </Box>
            </Grid>

            <Grid item xs={12} md={12}>
              <Box
                sx={{
                  display: "flex",
                  gap: 2,
                  flexDirection: { xs: "column", md: "row" }, // responsive
                }}
              >
                <Box sx={{ flex: 1 }}>
                  <InputLabel>Listing Type</InputLabel>
                  <TextField
                    select
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    error={!!requestErrors.clientType}
                    helperText={requestErrors.clientType?.message}
                    {...registerRequest("clientType", { required: "Listing type is required" })}
                  >
                    <MenuItem value="exclusive">Exclusive</MenuItem>
                    <MenuItem value="non-exclusive">Non Exclusive</MenuItem>
                  </TextField>
                </Box>

                <Box sx={{ flex: 1 }}>
                  <InputLabel>Purpose</InputLabel>
                  <TextField
                    select
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    error={!!requestErrors.purpose}
                    helperText={requestErrors.purpose?.message}
                    {...registerRequest("purpose", { required: "Purpose is required" })}
                  >
                    <MenuItem value="rent">Rent</MenuItem>
                    <MenuItem value="sale">Sale</MenuItem>
                  </TextField>
                </Box>
              </Box>
            </Grid>
            <Grid item xs={12}>
              <Button
                type="submit"
                variant="contained"
                sx={{ color: Colors.white }}
                fullWidth
              >
                {bookingLoading ? (
                  <Loader width="20px" height="20px" color={Colors.white} />
                ) : (
                  "Request listing"
                )}
              </Button>
            </Grid>
          </Grid>
        </form>
      </SimpleDialog>
    </>
  );
};

export default ProfessionalPropertyListing;
